export const TelephoneFilterModule = angular
    .module('app.filters.telephone', [])
    .filter('tel', () => {
        return (tel) => {
            if (tel === null || tel === undefined) { return ''; }
            if (typeof tel === 'string' && !tel.length) { return ''; }

            let value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            switch (true) {
                case value.length <= 3:
                    return `(${value}`;
                case value.length <= 6:
                    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}`;
                case value.length <= 10:
                    return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
                default:
                    return value;
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/filters/telephone.filter.js